import React, { useState, useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import Loader from "../components/Loader";
import axiosHttp from "../config/axios.interceptor";
import { Link, useLocation } from "react-router-dom";
import undrawProfile from "../img/undraw_profile.svg";
import serviceIcon from "../img/service.png";
import { truncateText } from "../../utils/application-helper";
import { AppContext } from "../contexts/AppContext";
import ReactPaginate from "react-paginate";
import { errorResponseMessage } from "../shared/const.prop";
import { filterReducerConstant } from "../store/reducerConstant";

const Search = () => {
  // const location = useLocation();
  // const { result } = location.state;
  const dispatch = useDispatch();
  const urlParams = new URLSearchParams(window.location.search);
  const { filterData } = useSelector((state) => state);
  const result = urlParams.get("search");
  const [searchResults, setSeachResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const appContext = useContext(AppContext);

  useEffect(() => {
    if (filterData.filterList.length !== 0) {
      setSeachResults(filterData.filterList);
    } else {
      getSearchResults(result);
    }
  }, [appContext.openModal]);

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Enter") {
        console.log("Enter key pressed");
        // Add your code here to handle the Enter key press event
      }
    };

    window.addEventListener("keydown", handleKeyPress);

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }); // No depend

  const getSearchResults = async (query) => {
    setLoading(true);
    if (query.trim() === "") {
      setSeachResults([]);
    } else {
      try {
        const results = await axiosHttp.get(`mentor-search?name=${query}`);
        if (results.status === 200) {
          let data = results?.data?.data;
          setSeachResults(data);
          if (filterData.filterList.length !== 0) {
            setSeachResults(filterData.filterList);
          }
        }
        setLoading(false);
      } catch (error) {
        if (error.response.status === 429) {
          appContext.updateNotificationState({
            show: true,
            message: errorResponseMessage(error),
            type: "error",
          });
          authContext.logout();
        }
        if (error.response.status === 400) {
          appContext.updateNotificationState({
            show: true,
            message: errorResponseMessage(error),
            type: "error",
          });
        }
        if (error.response?.status >= 500) {
          appContext.updateNotificationState({
            show: true,
            message: "Something went wrong, please try again later.",
            type: "error",
          });
        }
        setSeachResults([]);
        setLoading(false);
      }
    }
  };

  const advancedSearchHandler = () => {
    appContext.updateModalType("filter", "Filters");
  };

  const buildParams = (page) => {
    let params = {
      page: page,
    };
    let states = [];
    let categories = [];

    if (filterData.categories.length > 0) {
      filterData.categories.map((item) => {
        categories.push(`${item?._id}`);
      });
    }

    if (filterData.isSingle) {
      params.singleStart = filterData.singleAmount[0];
      params.singleEnd = filterData.singleAmount[1];
    }

    if (filterData.isWeekly) {
      params.weeklyStart = filterData.weeklyAmount[0];
      params.weeklyEnd = filterData.weeklyAmount[1];
    }

    if (filterData.isMonthly) {
      params.monthlyStart = filterData.monthlyAmount[0];
      params.monthlyEnd = filterData.monthlyAmount[1];
    }

    if (filterData.state.length > 0) {
      filterData.state.map((item) => {
        states.push(`${item?.id}`);
      });
    }

    if (categories.length !== 0) {
      params.categories = categories;
    }

    if (states.length !== 0) {
      params.states = states;
    }

    return params;
  };

  const handlePageClick = (event) => {
    const nextPage = event.selected + 1;
    const params = buildParams(nextPage);
    fetchResponse(params);
  };

  const fetchResponse = async (params) => {
    try {
      const resp = await axiosHttp.get(`mentor-advance-search`, {
        params,
      });
      if (resp?.status === 200) {
        dispatch({
          type: filterReducerConstant.UPDATE_FILTER_LIST,
          payload: {
            ...filterData,
            filterList:
              params?.page === 1
                ? resp?.data?.data
                : [...filterData.filterList, ...resp?.data?.data],
            currentPage: resp?.data?.meta?.currentPage,
            lastPage: resp?.data?.meta?.lastPage,
          },
        });
        setSeachResults(
          params?.page === 1
            ? resp?.data?.data
            : [...filterData.filterList, ...resp?.data?.data]
        );
      }
    } catch (error) {
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
        appContext.updateModalState();
        return;
      }
      appContext.updateNotificationState({
        show: true,
        message: errorResponseMessage(error),
        type: "error",
      });
      appContext.updateModalState();
    }
  };

  return loading ? (
    <Loader />
  ) : searchResults.length === 0 ? (
    <p>No results found</p>
  ) : (
    <>
      <div className="card card-one-1 margin">
        <div className="card-body">
          <div className="d-flex justify-content-between">
            {filterData.filterList.length === 0 ? (
              <p className="follow-txt">Search Results for {result}</p>
            ) : (
              <div>
                <p className="follow-txt">Advanced search results for</p>
                <p>
                  {filterData.states.length !== 0 &&
                    filterData.states.map((item) => item.name).join(", ")}
                </p>
                {filterData.isSingle && (
                  <div>
                    <p>
                      Single session minimum amount - Rs.{" "}
                      {filterData.singleAmount[0]}
                    </p>
                    <p>
                      Single session maximum amount - Rs.{" "}
                      {filterData.singleAmount[1]}
                    </p>
                  </div>
                )}
                {filterData.isWeekly && (
                  <div>
                    <p>
                      Weekly session minimum amount - Rs.
                      {filterData.weeklyAmount[0]}
                    </p>
                    <p>
                      Weekly session maximum amount - Rs.
                      {filterData.weeklyAmount[1]}
                    </p>
                  </div>
                )}
                {filterData.isMonthly && (
                  <div>
                    <p>
                      Monthly session minimum amount - Rs.{" "}
                      {filterData.monthlyAmount[0]}
                    </p>
                    <p>
                      Monthly session maximum amount - Rs.{" "}
                      {filterData.monthlyAmount[1]}
                    </p>
                  </div>
                )}
                <p>
                  {filterData.categories.length !== 0 &&
                    filterData.categories.map((item) => item.name).join(", ")}
                </p>
              </div>
            )}
            <button
              className="btn btn-primarybtn btn-primary follow-btn search-follow-btn advance-btn"
              onClick={advancedSearchHandler}
            >
              Filters
            </button>
          </div>
          {searchResults.length > 0 &&
            searchResults.map((item, index) => {
              return (
                <div className="row mb-3 individual-search" key={index}>
                  <Link to={`/${item.user_name}`}>
                    <div className="d-flex w-100 align-items-center">
                      <div>
                        <div className="sme-profile">
                          <img
                            className={`img-profile rounded-circle ${
                              item.offerService ? "sme-mini-service" : null
                            }`}
                            src={item.pic_url || undrawProfile}
                          />
                          {item?.offerService && (
                            <div className="sme-mini-icon">SME</div>
                          )}
                        </div>
                      </div>
                      <div className="ml-2">
                        <p className="mb-0">
                          <b>
                            {item?.fname || item?.lname
                              ? `${item?.fname || ""} ${item?.lname || ""}`
                              : item?.user_name}
                          </b>
                        </p>
                        <p className="mb-0">{item?.email_id}</p>
                        <p className="mb-0">
                          {item?.experience
                            ? truncateText(item?.experience, 45)
                            : ""}
                        </p>
                      </div>
                    </div>
                  </Link>
                </div>
              );
            })}
          {filterData.lastPage > 1 && (
            <ReactPaginate
              breakLabel="..."
              nextLabel=">"
              onPageChange={handlePageClick}
              pageRangeDisplayed={2}
              marginPagesDisplayed={0}
              pageCount={filterData.lastPage}
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakClassName="page-item"
              breakLinkClassName="page-link"
              containerClassName="pagination justify-content-end"
              activeClassName="active"
              previousLabel="<"
              forcePage={filterData.currentPage - 1}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default Search;
